import { Injectable } from '@angular/core';

import { IDocumentOption } from '@ib-shared/interfaces/document-option.intf';
import * as cs from 'credebt-shared';
@Injectable({ providedIn: 'root' })
export class RegistrDocTypesService {
  private _DOCUMENTS_OPTIONS: Array<IDocumentOption>;

  get DOCUMENTS_OPTIONS(): Array<IDocumentOption> {
    return this._DOCUMENTS_OPTIONS;
  }
  constructor() {
    this.initDocTypes();
  }

  initDocTypes(): void {
    this._DOCUMENTS_OPTIONS = [
      // {
      //   translateKey:
      //     'enums.documents.' + cs.INVESTOR_DOCUMENT_TYPE.UTILITY_BILL,
      //   type: cs.INVESTOR_DOCUMENT_TYPE.UTILITY_BILL,
      //   subType: cs.INVESTOR_DOCUMENT_SUBTYPE.TAX_DOC,
      //   accType: [
      //     cs.INVESTOR_ACCOUNT_TYPE.PERSONAL,
      //     cs.INVESTOR_ACCOUNT_TYPE.COMPANY,
      //   ] as Array<cs.INVESTOR_ACCOUNT_TYPE>,
      // },
      {
        translateKey:
          'enums.documents.' + cs.INVESTOR_DOCUMENT_TYPE.BANK_STATEMENT,
        type: cs.INVESTOR_DOCUMENT_TYPE.BANK_STATEMENT,
        subType: cs.INVESTOR_DOCUMENT_SUBTYPE.TAX_DOC,
        accType: [
          cs.INVESTOR_ACCOUNT_TYPE.PERSONAL,
          cs.INVESTOR_ACCOUNT_TYPE.COMPANY,
        ] as Array<cs.INVESTOR_ACCOUNT_TYPE>,
      },
      {
        translateKey: 'enums.documents.' + cs.INVESTOR_DOCUMENT_TYPE.ID_CARD,
        type: cs.INVESTOR_DOCUMENT_TYPE.ID_CARD,
        subType: cs.INVESTOR_DOCUMENT_SUBTYPE.ID_DOC,
        accType: [
          cs.INVESTOR_ACCOUNT_TYPE.PERSONAL,
        ] as Array<cs.INVESTOR_ACCOUNT_TYPE>,
      },
      {
        translateKey: 'enums.documents.' + cs.INVESTOR_DOCUMENT_TYPE.PASSPORT,
        type: cs.INVESTOR_DOCUMENT_TYPE.PASSPORT,
        subType: cs.INVESTOR_DOCUMENT_SUBTYPE.ID_DOC,
        accType: [
          cs.INVESTOR_ACCOUNT_TYPE.PERSONAL,
        ] as Array<cs.INVESTOR_ACCOUNT_TYPE>,
      },
      {
        translateKey:
          'enums.documents.' + cs.INVESTOR_DOCUMENT_TYPE.COMPANY_REG_DOC,
        type: cs.INVESTOR_DOCUMENT_TYPE.COMPANY_REG_DOC,
        subType: cs.INVESTOR_DOCUMENT_SUBTYPE.ID_DOC,
        accType: [
          cs.INVESTOR_ACCOUNT_TYPE.COMPANY,
        ] as Array<cs.INVESTOR_ACCOUNT_TYPE>,
      },
    ];
  }

  getDocSubTypeByType(
    type: cs.INVESTOR_DOCUMENT_TYPE,
  ): cs.INVESTOR_DOCUMENT_SUBTYPE {
    return this.DOCUMENTS_OPTIONS.find(i => i.type === type).subType;
  }
}
